import { formatDateDisplay } from './formatDateDisplay';
import { formatTime } from './formatTime';

/**
 * Locale-aware "<date> <time>" composition. Same locale, timezone, and style
 * options as `formatDateDisplay` and `formatTime` — the two helpers this
 * function delegates to.
 *
 * Sample output (UTC, `2026-06-15T13:45:00Z`):
 *   - `en-GB` → `"15/06/2026 13:45"`
 *   - `en-US` → `"06/15/2026 1:45 PM"`
 *
 * Returns `""` when the input is falsy or unparseable so JSX can render the
 * result unconditionally. Call sites that need a custom fallback (e.g. `N/A`)
 * should keep that fallback locally: `formatDateTime(x, opts) || 'N/A'`.
 *
 * @param {string | Date | null | undefined} datetime UTC ISO or `Date`.
 * @param {{ timezone?: string, locale?: string, style?: 'slashed' | 'dotted' }} [options]
 * @returns {string}
 */
export const formatDateTime = (datetime, options = {}) => {
	if (!datetime) return '';
	const date = formatDateDisplay(datetime, options);
	const time = formatTime(datetime, options);
	if (!date && !time) return '';
	return `${date} ${time}`.trim();
};
